<template>
  <tr class="border-b last:border-none">
    <td class="whitespace-nowrap p-3">
      <div class="h-10 w-10 bg-primary-200 dark:bg-primary-400/10 rounded-xl flex items-center justify-center font-semibold">
        <span class="text-primary-700 uppercase text-sm">{{ upload.extension || $t('components.upload.elements.list.file') }}</span>
      </div>
    </td>

    <td class="w-[99%] p-3 class flex items-start space-x-4">
      <div>
        <p class="opacity-90 font-medium text-[0.8rem]">
          {{ upload.caption }}
        </p>
        <p v-if="upload.size" class="text-sm opacity-70">
          {{ sizeLabel }}
        </p>
      </div>
    </td>

    <td class="whitespace-nowrap py-3 px-5">
      <p class="text-xs text-gray-500 dark:text-gray-400">
        {{ $t('components.upload.elements.list.dateUploaded') }}
      </p>
      <p class="text-sm text-gray-800 dark:text-gray-100">
        {{ createdLabel }}
      </p>
    </td>

    <td class="whitespace-nowrap py-3 px-5">
      <div class="flex items-center space-x-1">
        <o-button size="sm" flat icon="delete" @click="handleDelete" />
        <o-button size="sm" flat icon="view" @click="handlePreview" />
        <o-panel-link
          v-if="upload.reservation"
          :path="`/appointment/${upload.reservation.idReservation}?date=${upload.reservation.date}`"
          tag="o-button"
          size="sm"
          flat
          icon="reservation"
        />
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNuxtApp } from '#app'

const { $date } = useNuxtApp()

interface Props {
  upload: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'delete'): void
}>()

const createdLabel = computed(() => {
  const created = props.upload.created
  const format = $date.presets.compact

  return $date.format(created * 1000, format)
})

const sizeLabel = computed(() => {
  const upload = props.upload

  return upload.size > 1024
    ? upload.size > 1048576
      ? Math.round(upload.size / 1048576) + 'mb'
      : Math.round(upload.size / 1024) + 'kb'
    : upload.size + 'b'
})

function handlePreview () {
  emit('click')
}

function handleDelete () {
  emit('delete')
}
</script>
